<script lang="ts">
    import {dyData} from 'general/store';
    import {fly} from 'svelte/transition';

    import CustomerSupport from 'desktop/icons/CustomerSupport.svelte';
    import FreeShipping from 'desktop/icons/FreeShipping.svelte';
    import Guarantee from 'desktop/icons/Guarantee.svelte';
</script>

<style src="./style.css">
</style>

<div class="sv-container" class:smallScreen={$dyData.isSmallerScreen}>
    <p class="sv-title" class:hideTitle={$dyData.isSmallerScreen}>Shop with complete confidence</p>
    <div class="conditionsContainer" class:divider={$dyData.isSmallerScreen}>
        <div
            in:fly={{y: 200, duration: 200, delay: 0}}
            class="sv-item"
            class:itemSmallScreen={$dyData.isSmallerScreen}
        >
            <div class="sv-icon">
                <FreeShipping />
            </div>
            Free shipping and returns
        </div>
        <div
            in:fly={{y: 120, duration: 200, delay: 200}}
            class="sv-item"
            class:itemSmallScreen={$dyData.isSmallerScreen}
        >
            <div class="sv-icon">
                <Guarantee />
            </div>
            100% money-back guarantee
        </div>
        <div
            in:fly={{y: 40, duration: 200, delay: 400}}
            class="sv-item"
            class:itemSmallScreen={$dyData.isSmallerScreen}
            class:hideItem={$dyData.isSmallerScreen}
        >
            <div class="sv-icon">
                <CustomerSupport />
            </div>
            24/7 customer support
        </div>
    </div>
</div>
